import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/segmented-control/js/design-tokens-px.css.js';
import style from './mc-segmented-control.scss';
export const styles: CSSResultArray = [host, style, tokens];
